import {SHIPPING_METHOD_BINDING_CONTEXT_TYPE_ID} from './identifiers';

import type {
  BindingContextTypeDef,
  BindablePropertiesDef,
  TypeReferenceBuilder,
} from '@packages/systems/dynamo/source-types';

export const shippingMethodType: BindingContextTypeDef = {
  entity: 'Entity',
  id: SHIPPING_METHOD_BINDING_CONTEXT_TYPE_ID,
  label: 'Shipping Method',
  pluralLabel: 'Shipping Methods',
  singularLabel: 'Shipping Method',
  iconName: 'product',
};

export function shippingMethodBindableProperties<
  RootTRef,
  EntityTRef,
  ListTRef,
>(
  typeReferenceBuilder: TypeReferenceBuilder<RootTRef, EntityTRef, ListTRef>
): BindablePropertiesDef<EntityTRef, ListTRef> {
  return {
    type: typeReferenceBuilder.entityOf({
      entity: 'Entity',
      id: SHIPPING_METHOD_BINDING_CONTEXT_TYPE_ID,
    }),
    bindableProperties: [
      {
        id: 'shipping-method-name',
        type: 'PlainText',
        label: 'Name',
        path: [{id: '', slug: 'name', type: 'PlainText'}],
        queryPath: [],
        meta: {
          singleLine: true,
          minLength: null,
          maxLength: null,
          required: true,
        },
        rendering: {strategy: 'client'},
      },
      {
        id: 'shipping-method-description',
        type: 'PlainText',
        label: 'Description',
        path: [{id: '', slug: 'description', type: 'PlainText'}],
        queryPath: [],
        meta: {
          singleLine: false,
          minLength: null,
          maxLength: null,
          required: true,
        },
        rendering: {strategy: 'client'},
      },
      {
        id: 'shipping-method-price',
        type: 'CommercePrice',
        label: 'Price',
        path: [{id: '', slug: 'price', type: 'CommercePrice'}],
        queryPath: [],
        meta: {required: true},
        rendering: {strategy: 'client'},
      },
    ],
  };
}
